module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-20.c8f21503.jpg";